export default function ErrorState({ message = "دریافت اطلاعات با خطا مواجه شد.", onRetry, className = "" }) {
  return (
    <div role="alert" className={`w-full flex flex-col items-center justify-center gap-3 py-4 text-center ${className}`}>
      <p className="text-sm text-red-500">{message}</p>
      {onRetry && <button type="button" onClick={onRetry} className="rounded-lg border border-red-400 px-4 py-1.5 text-sm text-red-500">تلاش دوباره</button>}
    </div>
  );
}
